var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { propFunc, propId, propShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import { useBoolState } from '../../../../../../../helpers/use/useHook';
import UploadHistoryShareColRowForm from './UploadHistoryShareColRowForm';
const UploadHistoryShareColRow = (props) => {
    const { form, initialValues, onSubmit: rawOnSubmit, shareUser, slideId, userId, } = props;
    const { boolState: isEditMode, changeFalse: changeEditFalse, changeTrue: changeEditTrue, } = useBoolState(false);
    const onSubmit = useCallback((...arg) => __awaiter(void 0, void 0, void 0, function* () {
        yield rawOnSubmit(...arg);
        changeEditFalse();
    }), [rawOnSubmit, changeEditFalse]);
    return (_jsx(UploadHistoryShareColRowForm, { changeEditTrue: changeEditTrue, form: form, initialValues: initialValues, isEditMode: isEditMode, onSubmit: onSubmit, shareUser: shareUser, slideId: slideId, userId: userId }));
};
UploadHistoryShareColRow.propTypes = {
    form: propStr().isRequired,
    initialValues: propShape().isRequired,
    onSubmit: propFunc().isRequired,
    shareUser: propShape().isRequired,
    slideId: propId().isRequired,
    userId: propId().isRequired,
};
export default UploadHistoryShareColRow;
